import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SnackbarService } from 'src/app/layout/snackbars/snackbar.service';
import { AngularEditorConfig, AngularEditorModule } from '@kolkov/angular-editor';
import { SpinnerService } from 'src/app/layout/spinner.service';
import { MessageTemplate } from './main-settings.model';
import { MainSettingsService } from './main-settings.service';
import { MatDatepickerInputEvent, MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatTabChangeEvent, MatTabGroup, MatTab } from '@angular/material/tabs';
import { MatDivider } from '@angular/material/divider';
import { MatCard, MatCardSubtitle, MatCardContent } from '@angular/material/card';
import { MatFormField, MatLabel, MatInput, MatSuffix, MatHint } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';

@Component({
    selector: 'app-main-settings',
    templateUrl: './main-settings.component.html',
    styleUrls: ['./main-settings.component.scss'],
    imports: [MatDivider, MatTabGroup, MatTab, MatCard, MatCardSubtitle, MatCardContent, MatFormField, MatLabel, MatInput, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, MatButton, MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, FormsModule, ReactiveFormsModule, MatHint, AngularEditorModule]
})
export class MainSettingsComponent implements OnInit {

  fromDate = 0;
  toDate = 0;

  editorConfig: AngularEditorConfig = {
    editable: true,
      spellcheck: true,
      height: 'auto',
      minHeight: '0',
      maxHeight: 'auto',
      width: 'auto',
      minWidth: '0',
      translate: 'yes',
      enableToolbar: true,
      showToolbar: true,
      placeholder: 'Enter text here...',
      defaultParagraphSeparator: '',
      defaultFontName: '',
      defaultFontSize: '',
      fonts: [
        {class: 'arial', name: 'Arial'},
        {class: 'times-new-roman', name: 'Times New Roman'},
        {class: 'calibri', name: 'Calibri'},
        {class: 'comic-sans-ms', name: 'Comic Sans MS'}
      ],
      customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadUrl: 'v1/image',
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['insertVideo', 'insertImage'],
    ]
};

  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;
  constructor(
    private mainSettingsService: MainSettingsService,
    private spinnerService: SpinnerService,
    private snackbarService: SnackbarService,
  ) {

  }

  tab = 'templateSettings';
  templateForm: UntypedFormGroup;

  templates: MessageTemplate[] = [];
  ngOnInit(): void {
    this.getTemplates();

    this.templateForm = new UntypedFormGroup({
      templateSubject: new UntypedFormControl(),
      templateBody: new UntypedFormControl(),
    });
  }

  startCleaning() {
    this.mainSettingsService.clearRequests(this.fromDate, this.toDate).subscribe(
      (data: MessageTemplate[]) => {
        this.templates = data;
        this.spinnerService.stopSpinner();
      },

      (error: any) => {
        this.spinnerService.stopSpinner();
        this.snackbarService.openError(error.status);
      }
    );
  }

  addFromEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    this.fromDate = new Date(event.value).getTime();
  }

  addToEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    this.toDate = new Date(event.value).getTime();
  }

  tabChanged(event: MatTabChangeEvent): void {
    const selectedIndex = this.tabGroup.selectedIndex;

    // 0 = template settings
    if (selectedIndex === 0) {
      this.tab = 'templateSettings';
    }

    // 1 = mail settings
    if (selectedIndex === 1) {
      this.tab = 'mailSettings';
    }
  }

  // -- 0 TEMPLATE SETTINGS ---
  getTemplates(): void {
    this.spinnerService.startSpinner();
    this.mainSettingsService.fetchTemplates().subscribe(
      (data: MessageTemplate[]) => {
        this.templates = data;
        this.spinnerService.stopSpinner();
      },

      (error: any) => {
        this.spinnerService.stopSpinner();
        this.snackbarService.openError(error.status);
      }
    );
  }

  templatePanelChanged(id: number): void {
    this.templates.forEach((template: MessageTemplate) => {
      if (template.id === id) {
        this.templateForm.controls.templateSubject.setValue(template.subject);
        this.templateForm.controls.templateBody.setValue(template.templateBody);

        return;
      }
    });
  }

  saveTemplate(template: MessageTemplate): void {
    template.subject = this.templateForm.controls.templateSubject.value;
    template.templateBody = this.templateForm.controls.templateBody.value;

    this.spinnerService.startSpinner();
    this.mainSettingsService.putTemplate(template).subscribe(
      () => {
        this.spinnerService.stopSpinner();
        this.getTemplates();
        this.snackbarService.openSuccess();
      },
      (error: any) => {
        this.spinnerService.stopSpinner();
        this.snackbarService.openError(error.status);
      }
    );
  }
}
